export function apiMessage(error, fallback) {
  return error?.response?.data?.error?.message || error?.response?.data?.error || error?.message || fallback;
}
